/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di consumo di un\'istanza articolo (libro) di un voucher cedole
 */
export enum ArticoloPraticaStatus {

    DA_PRENOTARE_O_RITIRARE = 'DA_PRENOTARE_O_RITIRARE',

    PRENOTATO = 'PRENOTATO',

    RITIRATO = 'RITIRATO'
}

